import styled from 'styled-components'
import { MdPlace } from 'react-icons/md'

const PlantInfo = ({
  name,
  scientificName,
  place,
}: {
  name: string
  scientificName: string
  place: string
}) => {
  return (
    <Container>
      <Name>{name}</Name>
      <ScientificName>{scientificName}</ScientificName>
      <Place>
        <MdPlace /> {place}
      </Place>
    </Container>
  )
}

const Container = styled.div`
  position: absolute;
  bottom: 4vh;
  left: 50%;
  transform: translateX(-50%);
  width: 400px;
  text-align: center;
  line-height: 1.4;
  color: ${({ theme }) => `rgb(${theme.textColorOnBackground})`};

  ${({ theme }) => theme.breakpoints.down('md')} {
    bottom: 8vh;
  }
`

const Name = styled.div`
  font-weight: bold;
`

const ScientificName = styled.div`
  font-style: italic;
  font-size: ${({ theme }) => theme.textS};
  opacity: 0.65;
`

const Place = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: ${({ theme }) => theme.textS};
  opacity: 0.65;
`

export default PlantInfo
